import * as React from 'react';

const SvgDragAndDrop = (props) => (
  <svg
    width={9}
    height={14}
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 2.5C7.41421 2.5 7.75 2.16421 7.75 1.75C7.75 1.33579 7.41421 1 7 1C6.58579 1 6.25 1.33579 6.25 1.75C6.25 2.16421 6.58579 2.5 7 2.5Z"
      fill="currentColor"
    />
    <path
      d="M7 7.75C7.41421 7.75 7.75 7.41421 7.75 7C7.75 6.58579 7.41421 6.25 7 6.25C6.58579 6.25 6.25 6.58579 6.25 7C6.25 7.41421 6.58579 7.75 7 7.75Z"
      fill="currentColor"
    />
    <path
      d="M7 13C7.41421 13 7.75 12.6642 7.75 12.25C7.75 11.8358 7.41421 11.5 7 11.5C6.58579 11.5 6.25 11.8358 6.25 12.25C6.25 12.6642 6.58579 13 7 13Z"
      fill="currentColor"
    />
    <path
      d="M1.75 2.5C2.16421 2.5 2.5 2.16421 2.5 1.75C2.5 1.33579 2.16421 1 1.75 1C1.33579 1 1 1.33579 1 1.75C1 2.16421 1.33579 2.5 1.75 2.5Z"
      fill="currentColor"
    />
    <path
      d="M1.75 7.75C2.16421 7.75 2.5 7.41421 2.5 7C2.5 6.58579 2.16421 6.25 1.75 6.25C1.33579 6.25 1 6.58579 1 7C1 7.41421 1.33579 7.75 1.75 7.75Z"
      fill="currentColor"
    />
    <path
      d="M1.75 13C2.16421 13 2.5 12.6642 2.5 12.25C2.5 11.8358 2.16421 11.5 1.75 11.5C1.33579 11.5 1 11.8358 1 12.25C1 12.6642 1.33579 13 1.75 13Z"
      fill="currentColor"
    />
    <path
      d="M7 2.5C7.41421 2.5 7.75 2.16421 7.75 1.75C7.75 1.33579 7.41421 1 7 1C6.58579 1 6.25 1.33579 6.25 1.75C6.25 2.16421 6.58579 2.5 7 2.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 7.75C7.41421 7.75 7.75 7.41421 7.75 7C7.75 6.58579 7.41421 6.25 7 6.25C6.58579 6.25 6.25 6.58579 6.25 7C6.25 7.41421 6.58579 7.75 7 7.75Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 13C7.41421 13 7.75 12.6642 7.75 12.25C7.75 11.8358 7.41421 11.5 7 11.5C6.58579 11.5 6.25 11.8358 6.25 12.25C6.25 12.6642 6.58579 13 7 13Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 2.5C2.16421 2.5 2.5 2.16421 2.5 1.75C2.5 1.33579 2.16421 1 1.75 1C1.33579 1 1 1.33579 1 1.75C1 2.16421 1.33579 2.5 1.75 2.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 7.75C2.16421 7.75 2.5 7.41421 2.5 7C2.5 6.58579 2.16421 6.25 1.75 6.25C1.33579 6.25 1 6.58579 1 7C1 7.41421 1.33579 7.75 1.75 7.75Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 13C2.16421 13 2.5 12.6642 2.5 12.25C2.5 11.8358 2.16421 11.5 1.75 11.5C1.33579 11.5 1 11.8358 1 12.25C1 12.6642 1.33579 13 1.75 13Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgDragAndDrop;
